export const endAdvocateChat = 'End Advocate Chat';
export const cancelEndChatRequest = 'Cancel Request';
